import AxiosInstance from "src/api/AxiosInstance";
import { handleApiError } from "src/api/ErrorHandler";
import { ListParam } from "src/types/api/listParam";

export const getCorp = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get(`/channel/corp`, {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("corp 데이터 불러오기 실패:");
        return null;
    }
};

export const getScoreRank = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get(`/channel/rank/score`, {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("score 데이터 불러오기 실패:");
        return null;
    }
};

export const getSubRank = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get(`/channel/rank/subscribe`, {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("subscribe 데이터 불러오기 실패:");
        return null;
    }
};

export const getHotRank = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get(`/channel/rank/hot`, {
            params: params // 여기서 카테고리 아잉디 빼야함
        });
        return response.data;
    } catch (error) {
        handleApiError("실시간 급상승 데이터 불러오기 실패:");
        return null;
    }
};

export const getSector = async ( params: ListParam ) => {
    try {
        const response = await AxiosInstance.get(`/channel/sector`, {
            params: params
        });
        return response.data;
    } catch (error) {
        handleApiError("sector 데이터 불러오기 실패:");
        return null;
    }
};

export const getChannelDetail = async ( ChannelId: string ) => {
    try {
        const response = await AxiosInstance.get(`/channel/${ChannelId}`);
        return response.data;
    } catch (error) {
        handleApiError("sector 데이터 불러오기 실패:");
        return null;
    }
};